import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PendingInvitationsComponent from './pending-invitations.component';

let PendingInvitationsModule = angular
  .module('PendingInvitations', [
    uiRouter
  ])
  .component('pendingInvitations', PendingInvitationsComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state('pendingInvitations', {
      data: {
        authRequired: true,
        paymentExempt: true,
        permsRequired: []
      },
      params: {
        invitations: null,
        profiles: null
      },
      views: {
        'menu': "",
        'content': {
          component: 'pendingInvitations'
        }
      },
      resolve: {
        invitations: ($transition$) => {
          return $transition$.params().invitations || [];
        },
        profiles: ($transition$) => {
          return $transition$.params().profiles || [];
        },
      }
    });
  })
  .name;

export default PendingInvitationsModule;



// WEBPACK FOOTER //
// ./src/app/pages/pending-invitations/pending-invitations.module.js